import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useCurrentLabId } from './useCurrentLab';

interface AdminReturnTo {
  hash?: string;
  pathname: string;
  search?: string;
}

interface AdminNavigationState {
  adminReturnTo?: AdminReturnTo;
}

interface LocationLike {
  hash: string;
  pathname: string;
  search: string;
  state?: unknown;
}

const isAdminPath = (pathname: string) => pathname.startsWith('/admin/');

export const getAdminNavigationState = (location: LocationLike): AdminNavigationState | undefined => {
  const existingState = location.state as AdminNavigationState | null;

  if (existingState?.adminReturnTo) {
    return { adminReturnTo: existingState.adminReturnTo };
  }

  if (isAdminPath(location.pathname)) {
    return undefined;
  }

  return {
    adminReturnTo: {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    },
  };
};

export const useNavigateBackFromAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { labSearch } = useCurrentLabId();

  return React.useCallback(() => {
    const adminReturnTo = (location.state as AdminNavigationState | null)?.adminReturnTo;

    if (adminReturnTo) {
      navigate(adminReturnTo);
      return;
    }

    navigate({ pathname: '/', search: labSearch });
  }, [labSearch, location.state, navigate]);
};
